// [ai] table: rows of a query as a table; props.columns = [{key, label?}] (or field names), the list at props.path.
import { ErrorCard } from "../cards";
import { get, querySpec, rows, text, useHostQuery, Wait, type WidgetProps } from "./hooks";
import type { Schema } from "../props";
export const TABLE_PROPS: Schema = { columns: { type: "list", required: true }, path: { type: "string" }, limit: { type: "number" } };
type Col = { key: string; label?: string };
export function Table({ spec }: WidgetProps) {
  const p = spec.props as { columns: (Col | string)[]; path?: string; limit?: number }; const q = useHostQuery<unknown>(querySpec(spec, "library"));
  const cols: Col[] = p.columns.map(c => (typeof c === "string" ? { key: c } : c)).filter(c => c && typeof c.key === "string");
  if (!cols.length) return <ErrorCard text="props.columns needs at least one {key} column" />;
  if (q.error) return <ErrorCard text={q.error.message} />; if (q.data === undefined) return <Wait />;
  const list = rows(q.data, p.path).slice(0, p.limit ?? 50);
  return (
    <div className="at-cat at-cat-tablewrap"><table className="at-cat-table"><thead><tr>{cols.map(c => <th key={c.key}>{c.label ?? c.key}</th>)}</tr></thead>
      <tbody>{list.map((r, i) => <tr key={text(r.id ?? r.path ?? i)}>{cols.map(c => <td key={c.key}>{text(get(r, c.key))}</td>)}</tr>)}</tbody></table>{!list.length ? <p className="at-cat-empty">No rows.</p> : null}</div>
  );
}
